import { render, staticRenderFns } from "./CompanyEditNavigation.vue?vue&type=template&id=c59f95ee&scoped=true&"
import script from "./CompanyEditNavigation.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyEditNavigation.vue?vue&type=style&index=0&id=c59f95ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59f95ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c59f95ee')) {
      api.createRecord('c59f95ee', component.options)
    } else {
      api.reload('c59f95ee', component.options)
    }
    module.hot.accept("./CompanyEditNavigation.vue?vue&type=template&id=c59f95ee&scoped=true&", function () {
      api.rerender('c59f95ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditNavigation.vue"
export default component.exports